export default __webpack_public_path__ + "static/jagodowe-love-b658d88bf09bfddca72e5b11f48dcfcc.png";